export function AnalysisCard({ title, icon, onClick, className, selected }) {
    return (
      <button
        onClick={() => onClick()}
        className={`flex flex-col items-center justify-center p-6 rounded-lg transition-colors w-full aspect-square hover:bg-green-200 ${selected ? "bg-green-200": "bg-gray-200"} ${className || ""}`}
      >
        <div className="w-12 h-12 mb-4 text-green-600">{icon}</div>
        <span className="text-sm text-green-700">{title}</span>
      </button>
    )
  }
  
  